
/**
 * Utility functions for mapping display points to score points in Level 1
 */

export const getScorePoint = (displayPoint: string, testId: string | null, currentLevel: number): string => {
  // Si c'est un test de wedging au niveau 1
  if (testId?.includes('wedging') && currentLevel === 1) {
    // Pour wedging-cercles
    if (displayPoint === 'G') return 'WedgingA';
    if (displayPoint === 'H') return 'WedgingB';
    if (displayPoint === 'I') return 'WedgingC';
    
    // Pour wedging-pente-gauche
    if (displayPoint === 'G1') return 'WedgingA1';
    if (displayPoint === 'H1') return 'WedgingB1';
    if (displayPoint === 'I1') return 'WedgingC1';
    
    // Pour wedging-mid
    if (displayPoint === 'G2') return 'WedgingD';
    if (displayPoint === 'H2') return 'WedgingE';
    if (displayPoint === 'I2') return 'WedgingF';
    
    // Pour les points de score directs (quand on est déjà sur un point de type WedgingX)
    if (displayPoint.startsWith('Wedging')) return displayPoint;
  }
  // Si c'est un test de bunker-long au niveau 1
  else if (testId === 'bunker-long' && currentLevel === 1) {
    // Pour bunker-long, les points d'affichage sont G1/H1 mais nous voulons enregistrer sous G/H
    if (displayPoint === 'G1') return 'G';
    if (displayPoint === 'H1') return 'H';
  }
  // Pour fairwayWood-3, nous utilisons maintenant directement le point G
  
  return displayPoint;
};

export const getFirstPointForTest = (testId: string | null): string => {
  if (!testId) return "G";

  // Special points for putting tests
  if (testId === 'putts-plat') return 'G';
  if (testId === 'putts-montee') return 'G1';
  if (testId === 'putts-descente') return 'G2';
  if (testId === 'putts-pente') return 'G3';
  if (testId === 'putts-pente-droite') return 'G4';
  
  // Special points for chipping tests
  if (testId === 'chipping-plat') return 'G';
  if (testId === 'chipping-pente-droit') return 'G1';
  if (testId === 'chipping-roulee-plat') return 'G2';
  
  // Special points for wedging tests
  if (testId === 'wedging-cercles') return 'G';
  if (testId === 'wedging-pente-gauche') return 'G1';
  if (testId === 'wedging-mid') return 'G2';
  
  // Points spéciaux pour les tests bunker
  if (testId === 'bunker-long') return 'G1';
  
  // Point pour fairwayWood-3 - maintenant G au lieu de D
  if (testId === 'fairwayWood-3') return 'G';
  
  // Points pour les tests driver - driver-practice et driver-accuracy utilisent maintenant seulement G
  if (testId === 'driver-practice') return 'G';
  if (testId === 'driver-accuracy') return 'G';
  
  // Default points
  return 'G';
};
